export const ALPHANUMERIC_REGEX = /^[a-zA-ZÀ-ÿ0-9\s]{1,50}$/;

export const CEP_REGEX = /^\d{5}-\d{3}$/;
